export const carFleetData = [
  {
    image: "images/carfleet.png",
    name: "MG ZS EV",
    category: "Luxury",
    passengers: 4,
    fuelEfficiency: "5.6/100 MPG",
    pricePerDay: 1000,
  },
  {
    image: "images/carfleet.png",
    name: "MG ZS EV",
    category: "Luxury",
    passengers: 4,
    fuelEfficiency: "7.6/100 MPG",
    pricePerDay: 1000,
  },
  {
    image: "images/carfleet.png",
    name: "MG ZS EV",
    category: "Luxury",
    passengers: 4,
    fuelEfficiency: "5.6/100 MPG",
    pricePerDay: 1000,
  },
];

export const footerDetail = {
  description:
    "Farex is a pioneering travel-tech company committed to making intercity travel sustainable, affordable, and accessible for everyone. Since its launch, Farex Rides has provided cost-effective shared cab services, efficiently connecting cities while reducing environmental impact.",
};

export const homePageAboutDetail = {
  title: "Farex at a Glance",
  description:
    "Farex is a forward-thinking travel-tech company dedicated to transforming intercity mobility through smart, sustainable carpooling solutions. By offering cost-effective shared cab services, Farex makes long-distance travel more affordable, accessible, and eco-friendly. We offer both Carpooling—connecting everyday travelers to share private vehicle rides—and our premium Farex Shared Cabs, operated by professional drivers with guaranteed departures and zero last-minute cancellations.",
  highlightTitle: "Join us on the road to smarter, eco-friendly travel!",
  descriptionThird:
    "Be part of a movement that’s redefining how cities connect—smarter, cleaner, and together.",
  descriptionSecond:
    "Our platform connects travelers heading in the same direction, helping them save on commute costs, reduce their carbon footprint, and even expand their professional networks along the way. With every shared ride, we're reducing traffic congestion and making a tangible difference in environmental impact.",
};

export const homeBookingServicesData = [
  {
    id: "01",
    title: "Make Reservation",
    icon: "far fa-edit",
    description:
      "Choose your vehicle and enter your details to book your ride in just a few clicks.",
  },
  {
    id: "02",
    title: "Vehicle Confirmation",
    icon: "fas fa-taxi",
    description:
      "Receive instant confirmation with all the details of your reserved vehicle.",
  },
  {
    id: "03",
    title: "Enjoy your Trips",
    icon: "far fa-thumbs-up",
    description: "Sit back, relax, and enjoy a smooth and comfortable ride.",
  },
];

export const bookSeatData = [
  "Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat, sequi maiores? Explicabo consequatur dolorum voluptas.",
  "Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat, sequi maiores? Explicabo consequatur dolorum voluptas.",
  "Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat, sequi maiores? Explicabo consequatur dolorum voluptas.",
  "Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat, sequi maiores? Explicabo consequatur dolorum voluptas.",
];

export const CoPassengerSearchData = [
  "Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat, sequi maiores? Explicabo consequatur dolorum voluptas.",
  "Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat, sequi maiores? Explicabo consequatur dolorum voluptas.",
  "Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat, sequi maiores? Explicabo consequatur dolorum voluptas.",
  "Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat, sequi maiores? Explicabo consequatur dolorum voluptas.",
];


export const bookingInstructionData = [
  {
    id: 1,
    description: "No pets allowed",
  },
  {
    id: 2,
    description: "Respect pick-up time – be punctual",
  },
  {
    id: 3,
    description: "Keep noise to a minimum – use headphones for music/videos",
  },
  {
    id: 4,
    description: "Avoid strong scents – no heavy perfumes or strong-smelling food",
  },
  {
    id: 5,
    description: "Seatbelts must be worn at all times",
  },
  {
    id: 6,
    description: "Keep the vehicle clean – do not leave trash behind",
  },
  {
    id: 7,
    description: "Avoid last-minute cancellations",
  },
];


export const bookingStepsData = {
  step1: {
    mainTitle: "Get Started With Your Ride",
    mainDescription:
      "Let us know how you'd like to use our service. Select the option that best fits your needs:",
    options: [
      {
        iconClass: "fas fa-car",
        title: "Need A Car",
        description:
          "Book a reliable vehicle for your next trip, commute, or errand.",
        features: [
          "Wide range of vehicles to choose from",
          "Flexible booking options",
          "Affordable and transparent pricing",
          "Instant confirmation and easy pickup",
        ],
      },
      {
        iconClass: "fas fa-key",
        title: "Offer a Ride",
        description:
          "Planning to rent out your car? Stay tuned for this exciting feature.",
        features: [
          "Earn extra income from your vehicle",
          "Full control over availability and pricing",
          "Insurance and support included",
        ],
      },
    ],
  },
  step2: {
    mainTitle: "Plan Your Ride",
    mainDescription:
      "Choose how you want to travel and connect with others for a smoother, more cost-effective journey:",
    options: [
      {
        iconClass: "fas fa-car-alt",
        title: "Book A Seat",
        description: "Reserve a seat in a vehicle headed in your direction.",
        features: [
          "Browse available rides quickly",
          "Affordable shared travel",
          "Meet new people along the way",
          "Convenient pickup and drop-off points",
        ],
      },
      {
        iconClass: "fas fa-user-plus",
        title: "Search A Co-Passenger",
        description:
          "Looking for someone to share your ride? Find a travel buddy.",
        features: [
          "Split travel costs",
          "Travel more safely and socially",
          "Post your trip and get matched",
          "Flexible scheduling based on your needs",
        ],
      },
    ],
  },
  step3: {
    mainTitle: "Plan Your Journey",
    mainDescription:
      "Enter your travel details to find the best available rides:",
    options: [
      {
        iconClass: "fas fa-map-marker-alt",
        title: "From",
        description: "Select your starting location.",
        features: [
          "Smart autocomplete for quick selection",
          "Supports all major cities and towns",
          "Real-time filtering as you type",
        ],
      },
      {
        iconClass: "fas fa-map-signs",
        title: "To",
        description: "Choose your destination.",
        features: [
          "Easy-to-use location search",
          "Get connected to nearby drop-off points",
          "Accurate and fast results",
        ],
      },
      {
        iconClass: "fas fa-calendar-alt",
        title: "Date",
        description: "Pick your travel date.",
        features: [
          "Future dates only",
          "Prevents past-date errors",
          "Smooth calendar interaction",
        ],
      },
      {
        iconClass: "fas fa-search",
        title: "Search",
        description: "Click the Search button to view matching rides.",
        features: ["Fast and accurate results", "Instantly see trip details"],
      },
    ],
  },
};

export const driverMessageTemplate = (
  date,
  year,
  customer_name,
  customer_detail,
  route
) =>
  `New Booking Alert for ${date}th, ${year}. Customer: ${customer_name} Contact: ${customer_detail} Route: ${route} Ride confirmation is still pending Kindly contact the passenger to confirm the seat for the journey. Team - FAREX`;

export const userMessageTemplate = (
  route,
  date,
  routeMain,
  customer_name,
  time,
  driver_name,
  driver_detail
) =>
  `Dear ${customer_name}, your ride from ${route} is booked for ${date} at ${routeMain} is booked for ${time}. Driver:  ${driver_name} | Contact: ${driver_detail}. Kindly contact the driver to confirm your ride. Have a safe journey! Team - Farex`;
